module.exports = __webpack_public_path__ + "static/remote_more-5769ee92ea175a40f46b94fc22f85cac.svg";